// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { BrokenPageRepoService } from '@client/app/services/api/broken-page-repo/broken-page-repo.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'broken-pages-index',
    standalone: false,
    template: `
        <page-header
                [icon]="(['QA', 'CONTENT_BROKEN_LINKS'] | monIcons)"
                [header]="('Broken Content by Page' | translate)"
                [subHeader]="'<strong>' + (pages.total | monNumber) + '</strong> ' + ('page' | translateWithPlural:pages.total:'pages')">
        </page-header>
        <mon-tabs
                [search]="search"
                [minSearchLength]="1"
                [options]="tabs"
                [(status)]="activeTab"
                (onStatus)="onStatus($event)"
                (onSearch)="onSearch($event)"
                [showFiltersBtn]="showFilters"
                [(isFiltersOpen)]="isFiltersOpen"
                [showSearch]="true">
            <csv-export-button [exports]="exports"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-48 col-lg-48 col-48">
                        <pages-table
                                [pages]="pages"
                                (onPageSort)="onSortPage($event.direction, $event.by)"
                                (onPageChange)="onPageChange($event)"
                                (onPerPageChange)="onPageSizeChange($event)"
                                [tab]="activeTab"
                                [showNotifications]="showNotifications"
                                [progress]="promise"
                                [currentSort]="currentSort"
                                [(isFiltersOpen)]="isFiltersOpen"
                                (onFiltersChanges)="onFiltersChanges($event)"
                                [target]="'page-details-section-qa'"
                                [subTarget]="'brokenlinks'">
                        </pages-table>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class BrokenPagesIndexComponent extends BaseContainerComponentController implements OnInit {
    exports: any[] = [];
    pages: any = [];
    tabs: any[] = [];
    showNotifications: string[] = [];
    promise: any;

    constructor (
        private brokenPageRepoService: BrokenPageRepoService,
        private paramService: ParamService,
        private translateService: TranslateService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.exports = [
            {
                name: this.translateService.getString('Broken Content by Page'),
                data: {
                    category: 'pages_with_broken_links',
                },
            },
        ];
        this.pages = [];
        this.tabs = [
            {
                name: this.translateService.getString('All'),
                faIcon: 'fas fa-copy',
                value: '',
            },
            {
                name: this.translateService.getString('Pages'),
                faIcon: 'fas fa-window-maximize',
                value: 'html',
            },
        ];
        this.activeTab = '';

        if (this.sessionService?.domain?.scan?.scan_documents) {
            this.tabs.push({ name: 'PDF Documents', faIcon: 'fas fa-file-pdf', value: 'pdf' });
            this.tabs.push({ name: 'Text Documents', faIcon: 'fas fa-file-alt', value: 'document' });
        }
        this.showNotifications = ['dead-links', 'broken-images'];
        this.loadLocations();
        this.getPage();
    }

    loadLocations (): void {
        this.currentSort = { direction: 'desc', by: 'priority_score' };
        this.search = this.urlService.search().search || '';
        this.currentSort.by = this.urlService.search().sort_by || 'priority_score';
        this.currentSort.direction = this.urlService.search().sort_dir || 'desc';
        this.activeTab = this.urlService.search().type || '';
    }

    override getPage (): void {
        this.paramService.setParams({
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            search: this.search || null,
            type: this.activeTab || null,
        });
        this.getPages();
    }

    getPages (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search || null,
            sort_by: this.currentSort.by === 'notification_count' ? 'dead_count' : this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        if (this.activeTab && this.activeTab !== '') {
            params['types[]'] = [this.activeTab];
        }

        const updatedParams = this.updateParamsWithFilters(params);

        this.promise = this.brokenPageRepoService.get(updatedParams).then((data: any) => {
            this.pages = data;
        }, () => {});
    }

    onFiltersChanges (changes: any): void {
        this.updateFilters(changes);
        this.getPage();
    }
}
